import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export const AgreementLabel = ({ value, testId = 'benefit-agreement-summary' }) => (
  <p className="text-sm font-medium break-words" data-testid={testId}>
    {value.entitlement_is_set ? `HR agreement: ${value.entitlement_days} days / ${value.cycle_years} year${value.cycle_years === 1 ? '' : 's'}`
      : `Default ${value.entitlement_days} days / ${value.cycle_years} year${value.cycle_years === 1 ? '' : 's'} — not set by HR`}
  </p>
);

export const AnnualConfigurationSummary = ({ employeeId }) => {
  const { token } = useAuth();
  const [value, setValue] = useState(null), [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/employees/${employeeId}/leave-benefits/configuration`,
      { headers: { Authorization: `Bearer ${token}` } }).then(r => { if (active) setValue(r.data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [employeeId, token]);
  return <section className="border-t pt-5 space-y-3 min-w-0" data-testid="annual-leave-readonly-summary">
    <h3 className="font-medium">Annual leave</h3>
    {error ? <p data-testid="annual-summary-error" role="alert">Annual leave summary could not be loaded.</p>
      : !value ? <p data-testid="annual-summary-loading">Loading agreement…</p>
      : <>
        {value.entitlement_days !== undefined && <AgreementLabel value={value} testId="annual-edit-agreement-summary" />}
        <p className="text-sm" data-testid="annual-edit-accrual-start">Balance counted from: {value.accrual_start || 'Not recorded'}{value.accrual_basis === 'continuous' ? ' · current rate; earlier earnings preserved' : ''}</p>
        <p className="text-sm" data-testid="annual-edit-rejoin-date">Rejoin Date: {value.rejoin_date || 'Not recorded'}</p>
        <p className="text-sm" data-testid="annual-edit-last-start">Last Annual Leave Start Date: {value.last_leave_start || 'Not recorded'}</p>
      </>}
    <Link className="inline-flex items-center gap-2 text-sm underline underline-offset-4 text-brand-brown hover:opacity-80 transition-opacity"
      to={`/employees/${employeeId}?tab=leave-benefits`} data-testid="annual-open-leave-benefits">
      Leave & Benefits <ArrowUpRight className="h-4 w-4" />
    </Link>
  </section>;
};